import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/appConstants'

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-white font-bold text-lg">Studiebijbaan.nl</h3>
            <p className="mt-2 text-sm leading-relaxed">
              Het platform voor studenten en werkgevers.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-3">
              Navigatie
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Homepagina</Link></li>
              <li><Link to="/search-results" className="hover:text-white transition-colors">Vacatures</Link></li>
              <li><Link to="/blogs" className="hover:text-white transition-colors">Blogs</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Employers */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-3">
              Voor werkgevers
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/dashboard/plaats-vacature" className="hover:text-white transition-colors">Vacature plaatsen</Link></li>
              <li><Link to={ROUTES.REGISTER} className="hover:text-white transition-colors">Registreren</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 text-sm text-center">
          &copy; {new Date().getFullYear()} Studiebijbaan.nl
        </div>
      </div>
    </footer>
  )
}

export default Footer
